  <p-select appendTo="body"  [style]="{ width: '100%'}" placeholder="Register" optionLabel="label" (onChange)="itemSelected($event)" class="dropdown" [options]="menuListItems" [(ngModel)]="selectedOption" [showHeader]="false"
  >
  <ng-template let-selected pTemplate="selectedItem">
    {{selected.label|translate}}
  </ng-template>
  <ng-template let-item pTemplate="item">
    {{item.label|translate}}
  </ng-template>
</p-select>
